import { createContext } from 'react';
export const UTXOExternalContext = createContext(false);
//# sourceMappingURL=UTXOExternalContext.js.map